import { Injectable } from '@angular/core';

import { TinymceCssComponent } from '../../components/common/tinymce-css/tinymce-css.component';

declare var tinymce: any;
declare var jQuery: any;
declare var $: any;
declare var window: any;

@Injectable()
export class TinymceService {
  stylesheets_selected: any;
  css_files: any;
  stylesheet_formats: any;
  tinymceCssComponents: Array<TinymceCssComponent> | any = [];

  constructor() {}

  tinymce_schema_init() {
    if (typeof tinymce === 'undefined' || typeof tinymce.init !== 'function') return;
    if ($('#tinymce_schema_holder').length < 1) {
      $('body').append('<div class="tinymce_initialize" style="display: none;"><textarea class="tinymce_init" id="tinymce_schema_holder"></textarea></div>');
      tinymce.init({
        selector: '.tinymce_init',
        branding: false,
        menubar: true,
        theme: 'silver',
        plugins: 'advlist autolink lists link image charmap print preview hr anchor pagebreak,searchreplace wordcount visualblocks visualchars code fullscreen,insertdatetime media nonbreaking save table directionality,emoticons template paste textpattern pagebreak',
        toolbar1: 'insertfile undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist olnumberstarter outdent indent tabspacer | link image',
        toolbar2: 'print preview media | forecolor backcolor emoticons',
        image_advtab: true,
        importcss_merge_classes: true,
        nonbreaking_force_tab: true,
        advlist_number_styles: 'decimal,lower-alpha,lower-greek,lower-roman,upper-alpha,upper-roman',
        setup: (editor: any) => {
          this.setFocusAndBlur(editor);
          this.add_tabspacer_tinymce(editor);
          this.add_start_number_ol_tinymce(editor);
          this.font_size_change_tinymce(editor);
        },
        pagebreak_separator: "<div style='display:block; clear:both; page-break-after:always;'></div>",
      });
    }
  }

  loadCSS(stylesheets_selected: any, scope: any, tinymceCssComponents: Array<TinymceCssComponent> | any, callback: Function) {
    if (scope.css_files && scope.stylesheet_formats) this.applyCSSActual(scope.css_files, scope.stylesheet_formats, scope, this, tinymceCssComponents, callback);
    else {
      var stylesheets: any = {};
      var css_files: any = [];
      for (var i in stylesheets_selected) {
        var stylesheet = stylesheets_selected[i];
        if (stylesheets[stylesheet.group_name]) stylesheets[stylesheet.group_name].push('/stylesheets/' + stylesheet.id + '.css');
        else stylesheets[stylesheet.group_name] = ['/stylesheets/' + stylesheet.id + '.css'];
        css_files.push('/stylesheets/' + stylesheet.id + '.css');
      }
      css_files.push('/stylesheets/default.css');
      this.fetch_style_formats(css_files, stylesheets, {}, scope, this, tinymceCssComponents, callback);
    }
  }

  fetch_style_formats(css_files: any, stylesheets: any, stylesheet_formats: any, scope: any, this_scope: TinymceService, tinymceCssComponents: Array<TinymceCssComponent> | any, callback: Function) {
    if (Object.keys(stylesheets).length > 0) {
      if (!this_scope) this_scope = this;
      for (var i in stylesheets) {
        if (!stylesheet_formats[i]) stylesheet_formats[i] = [];
        for (var j in stylesheets[i]) {
          $.ajax({
            data: {},
            complete: function (xhr: any, status: any) {
              stylesheets[i].splice(j, 1);
              if (stylesheets[i].length < 1) delete stylesheets[i];
              this_scope.fetch_style_formats(css_files, stylesheets, stylesheet_formats, scope, this_scope, tinymceCssComponents, callback);
            },
            success: function (data: any, status: any, xhr: any) {
              stylesheet_formats[i].push(data);
            },
            url: stylesheets[i][j],
          });
          break;
        }
        break;
      }
    } else this_scope.applyCSSActual(css_files, stylesheet_formats, scope, this_scope, tinymceCssComponents, callback);
  }

  applyCSSActual(css_files: any, stylesheet_formats: any, scope: any, this_scope: TinymceService, tinymceCssComponents: Array<TinymceCssComponent> | any, callback: Function) {
    if (!scope.css_files || !scope.stylesheet_formats) {
      scope.css_files = css_files;
      scope.stylesheet_formats = this_scope.prep_stylesheet_formats_actual(stylesheet_formats);
    }
    setTimeout(() => {
      if (tinymceCssComponents && tinymceCssComponents.toArray) tinymceCssComponents = tinymceCssComponents.toArray();
      for (let tinymceCssComponent of tinymceCssComponents) tinymceCssComponent.initializeTinymce(css_files, scope.stylesheet_formats);
      if (callback) callback(scope);
    }, 1000);
  }

  prep_stylesheet_formats_actual(stylesheet_formats: any) {
    var result = [];
    var items = [];
    window.font_faces = [];
    var editor = undefined;
    console.log(tinymce.editors);
    for (var x in tinymce.editors) {
      console.log(tinymce.editors[x]);
      if ($(tinymce.editors[x].targetElm).attr('class') == 'tinymce_init') {
        editor = tinymce.editors[x];
        break;
      }
    }
    for (var i in stylesheet_formats) {
      items = [];
      for (var j in stylesheet_formats[i]) {
        var data = stylesheet_formats[i][j];
        data = data.replace(/[\n\r]/g, '');
        data = data.replace(/\/\*.*\*\//g, '');
        data = data.split('}');
        for (var k in data) {
          var tmp = data[k].split('{');
          if (tmp.length > 1) {
            var format: any;
            tmp[0] = tmp[0].split(',');
            for (var x in tmp[0]) {
              var selector = /^(?:([a-z0-9\-_]+))?(\.[a-z0-9_\-\.]+)$/i.exec(tmp[0][x].trim());
              if (!selector) continue;
              var elementName = selector[1];
              var classes = selector[2].substr(1).split('.').join(' ');
              var inlineSelectorElements = tinymce.makeMap('a,img');
              // element.class - Produce block formats
              if (selector[1]) {
                format = {
                  title: tmp[0][x].trim(),
                };

                if (editor.schema.getTextBlockElements()[elementName]) {
                  // Text block format ex: h1.class1
                  format.block = elementName;
                } else if (editor.schema.getBlockElements()[elementName] || inlineSelectorElements[elementName.toLowerCase()]) {
                  // Block elements such as table.class and special inline elements such as a.class or img.class
                  format.selector = elementName;
                } else {
                  // Inline format strong.class1
                  format.inline = elementName;
                }
              } else if (selector[2]) {
                // .class - Produce inline span with classes
                format = {
                  inline: 'span',
                  title: tmp[0][x].trim().substr(1),
                  classes: classes,
                };
              }

              // Append to or override class attribute
              if (editor)
                if (editor.settings.importcss_merge_classes !== false) {
                  format.classes = classes;
                } else {
                  format.attributes = { class: classes };
                }
              else format.classes = classes;

              items.push(format);
            }
          }
        }
      }
      result.push({ title: i, items: items });
    }
    return result;
  }

  format_css_selector(selector: any, get_selector: any) {
    if (get_selector) {
      if (selector[0] == '.') return 'div';
      return selector.split('.')[0];
    } else {
      if (selector[0] == '.') selector = selector.split('.').splice(1);
      else selector = selector.split('.');
      selector = selector.join(' ');
      return selector;
    }
  }

  check_style_selector(selector: any, styles_str: any) {
    if (selector) {
      if (selector.indexOf('@') > -1) {
        if (selector == '@font-face') window.font_faces.push(styles_str);
        return false;
      }
      if (/pseudo|\:|,|\s|>/g.test(selector)) return false;
      return true;
    }
    return false;
  }

  randomString(len: number) {
    var text = '';
    var charset = 'abcdefghijklmnopqrstuvwxyz0123456789';
    var len = charset.length;
    for (var i = 0; i < len; i++) text += charset.charAt(Math.floor(Math.random() * len));
    return text;
  }

  setFocusAndBlur(ed: any) {
    ed.on('blur', (e: any) => {
      var textarea = $('#' + $(this)[0].id);
      if (textarea.parents('.part_form').length == 0) {
        $('.part_form').find('.part_container:first').find('.part_name').focus();
      }
    });
  }

  add_tabspacer_tinymce(ed: any) {
    ed.ui.registry.addButton('tabspacer', {
      title: 'Tab space',
      icon: 'nonbreaking',
      onAction: function () {
        ed.insertContent('&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;');
      },
    });
  }

  add_double_space_tinymce(ed: any) {
    let scope = this;
    ed.ui.registry.addButton('doublespace', {
      title: 'Double Space',
      text: 'Double',
      onAction: function () {
        scope.set_document_line_spacing_tinymce(ed, '2');
      },
    });
  }

  set_document_line_spacing_tinymce(ed: any, spacing: string) {
    const body = ed.getBody();
    const existingWrapper = body.querySelector('.plo-document-line-spacing');
    const content = ed.getContent();

    ed.undoManager.transact(() => {
      if (existingWrapper && existingWrapper.parentNode === body && body.children.length === 1) {
        existingWrapper.style.lineHeight = spacing;
      } else {
        ed.setContent('<div class="plo-document-line-spacing" style="line-height: ' + spacing + ';">' + content + '</div>');
      }
    });

    ed.fire('change');
    ed.nodeChanged();
  }

  add_start_number_ol_tinymce(ed: any) {
    let scope = this;
    ed.ui.registry.addButton('olnumberstarter', {
      title: 'Numbered List - start number',
      icon: 'numlist',
      onAction: function () {
        scope.insert_start_number_ol_tinymce_dialog(ed);
      },
    });
  }

  insert_start_number_ol_tinymce_dialog(ed: any) {
    var html =
      '<div>\
                <div class="form-group">\
                  <label for="start_number_ol_tag">Start number</label>\
                  <input placeholder="Start number" class="form-control input-sm" id="start_number_ol_tag_tinymce" type="text" />\
                </div>\
                <div class="form-group">\
                  <label for="numlist_type">List style type</label>\
                  <select class="form-control input-sm" id="numlist_type_tinymce">\
                    <option value="decimal">Decimal</option>\
                    <option value="decimal-leading-zero">Decimal Leading Zero</option>\
                    <option value="lower-alpha">Lower Alpha</option>\
                    <option value="lower-greek">Lower Greek</option>\
                    <option value="lower-latin">Lower Latin</option>\
                    <option value="lower-roman">Lower Roman</option>\
                    <option value="upper-alpha">Upper Alpha</option>\
                    <option value="upper-latin">Upper Latin</option>\
                    <option value="upper-roman">Upper Roman</option>\
                    <option value="none">None</option>\
                  </select>\
                </div>\
                <div class="form-group">\
                  <label for="numlist_spacing">List spacing</label>\
                  <select class="form-control input-sm" id="numlist_spacing_tinymce">\
                    <option value="0">None</option>\
                    <option value="0.5">None</option>\
                    <option value="1.0">1.0</option>\
                    <option value="1.5">1.5</option>\
                    <option value="2.0">2.0</option>\
                    <option value="2.5">2.5</option>\
                    <option value="3.0">3.0</option>\
                  </select>\
                </div>\
              </div>';
    if ($('#jquery_dialog').length < 1) $('body').append('<div id="jquery_dialog"></div>');
    $('#jquery_dialog').dialog({
      open: function (dEvent: any, ui: any) {
        this.innerHTML = html;
      },
      close: function (dEvent: any, ui: any) {
        this.innerHTML = '';
      },
      modal: true,
      title: 'Insert numbered list',
      width: 500,
      buttons: {
        Insert: function () {
          var start_number = $('#start_number_ol_tag_tinymce').val();
          var list_style_type = $('#numlist_type_tinymce').val();
          var list_spacing = $('#numlist_spacing_tinymce').val();
          if (!Number(start_number)) start_number = '1';
          if (!list_style_type) list_style_type = 'decimal';
          if (!list_spacing) list_spacing = 0;
          var spacing_class = '';
          switch (String(list_spacing)) {
            case '0':
            case '0.0':
              spacing_class = 'li_0';
              break;
            case '0.5':
              spacing_class = 'li_0_5';
              break;
            case '1':
            case '1.0':
              spacing_class = 'li_1';
              break;
            case '1.5':
              spacing_class = 'li_1_5';
              break;
            case '2':
            case '2.0':
              spacing_class = 'li_2';
              break;
            case '2.5':
              spacing_class = 'li_2_5';
              break;
            case '3':
            case '3.0':
              spacing_class = 'li_3';
              break;
          }
          //ed.dom.create('ol', {'start': start_number, 'list-style-type': list_style_type}, '<li></li>');
          ed.dom.add(ed.getBody(), 'ol', { start: start_number, style: 'list-style-type: ' + list_style_type + ';', class: spacing_class }, '<li></li>');
          $('#jquery_dialog').dialog('close');
        },
        Cancel: function () {
          $('#jquery_dialog').dialog('close');
        },
      },
    });
    $('#jquery_dialog').dialog('close');
    $('#jquery_dialog').dialog('open');
  }

  font_size_change_tinymce(ed: any) {
    let scope = this;
    var font_size_options = [];
    for (var i = 5; i < 100; i++) font_size_options.push({ text: i + 'pt', value: i });
    ed.ui.registry.addButton('fontsizechange', {
      title: 'Font Size',
      text: 'Font Sizes',
      type: 'listbox',
      onselect: function (v: any) {
        console.log(v);
        scope.insert_font_size_change_tinymce(ed, v.target.value());
      },
      onPostRender: function () {},
      values: font_size_options,
    });
  }

  watermark_tinymce(ed: any) {}

  insert_logo_tinymce_button(ed: any) {
    let scope = this;
    ed.ui.registry.addButton('insertlogo', {
      title: 'Insert logo',
      text: 'Ins logo',
      onAction: function () {
        scope.insert_logo_tinymce_dialog(ed);
      },
    });
  }

  insert_logo_tinymce_dialog(ed: any) {
    if (window.logos.length) {
      var logo_options = '';
      for (var i in window.logos) logo_options += '<option value="' + window.logos[i].url + '">' + window.logos[i].name + '</option>';
      var html =
        '<div>\
	                  <ul class="nav nav-tabs">\
	                    <li class="active"><a href="#logo_dialog_general_tab" data-toggle="tab">General</a></li>\
	                    <li><a href="#logo_dialog_advanced_tab" data-toggle="tab">Advanced</a></li>\
	                  </ul>\
	                  <div class="tab-content">\
	                    <div id="logo_dialog_general_tab" class="tab-pane active">\
	                      <br />\
	                      <div class="form-group">\
	                        <div class="row">\
	                          <div class="col-md-4">\
	                            <label>Logo</label>\
	                          </div>\
	                          <div class="col-md-8">\
	                            <select id="logo_insert_source" class="form-control">\
	                              ' +
        logo_options +
        '\
	                            </select>\
	                          </div>\
	                        </div>\
	                      </div>\
	                      <div class="form-group">\
	                        <div class="row">\
	                          <div class="col-md-4">\
	                            <label>Image Description</label>\
	                          </div>\
	                          <div class="col-md-8">\
	                            <input id="logo_insert_image_description" class="form-control" />\
	                          </div>\
	                        </div>\
	                      </div>\
	                      <div class="form-group">\
	                        <div class="row">\
	                          <div class="col-md-2">\
	                            <label>Dimensions</label>\
	                          </div>\
	                          <div class="col-md-2">\
	                            <input id="logo_insert_width" class="form-control" />\
	                          </div>\
	                          <div class="col-md-1 text-center">\
	                            <label>x</label>\
	                          </div>\
	                          <div class="col-md-2">\
	                            <input id="logo_insert_height" class="form-control" />\
	                          </div>\
	                          <div class="col-md-5">\
	                            <div class="checkbox">\
	                              <label>\
	                                <input id="logo_insert_constrain" type="checkbox" />Constrain proportions\
	                              </label>\
	                            </div>\
	                          </div>\
	                        </div>\
	                      </div>\
	                      <div class="form-group">\
	                      </div>\
	                    </div>\
	                    <div id="logo_dialog_advanced_tab" class="tab-pane">\
	                      <br />\
	                      <div class="form-group">\
	                        <div class="row">\
	                          <div class="col-md-3">\
	                            <label>Style</label>\
	                          </div>\
	                          <div class="col-md-9">\
	                            <input id="logo_insert_style" class="form-control" />\
	                          </div>\
	                        </div>\
	                      </div>\
	                      <div class="form-group">\
	                        <div class="row">\
	                          <div class="col-md-3">\
	                            <label>Vertical space</label>\
	                          </div>\
	                          <div class="col-md-2">\
	                            <input id="logo_insert_vspace" class="form-control" />\
	                          </div>\
	                          <div class="col-md-4 text-center">\
	                            <label>Horizontal space</label>\
	                          </div>\
	                          <div class="col-md-2">\
	                            <input id="logo_insert_hspace" class="form-control" />\
	                          </div>\
	                        </div>\
	                      </div>\
	                      <div class="form-group">\
	                        <div class="row">\
	                          <div class="col-md-3">\
	                            <label>Border</label>\
	                          </div>\
	                          <div class="col-md-9">\
	                            <input id="logo_insert_border" class="form-control" />\
	                          </div>\
	                        </div>\
	                      </div>\
	                    </div>\
	                  </div>\
	                </div>';
      if ($('#jquery_dialog').length < 1) $('body').append('<div id="jquery_dialog"></div>');
      $('#jquery_dialog').dialog({
        open: function (dEvent: any, ui: any) {
          this.innerHTML = html;
        },
        close: function (dEvent: any, ui: any) {
          this.innerHTML = '';
        },
        modal: true,
        title: 'Insert Logo Image',
        width: 500,
        buttons: {
          Insert: function () {
            var dialog = $('#jquery_dialog');
            var src = dialog.find('#logo_insert_source').val();
            var alt = dialog.find('#logo_insert_image_description').val() || 'Logo';
            var width = dialog.find('#logo_insert_width').val() || 'auto';
            var height = dialog.find('#logo_insert_height').val() || 'auto';
            var constrain = dialog.find('#logo_insert_constrain').prop('checked');
            var style = dialog.find('#logo_insert_style');
            var vspace = dialog.find('#logo_insert_vspace').val() || '0';
            var hspace = dialog.find('#logo_insert_hspace').val() || '0';
            var border = dialog.find('#logo_insert_border').val() || 'none';
            var cursor_elem = ed.selection.getRng().endContainer;
            console.log(cursor_elem);
            if (!cursor_elem.tagName && cursor_elem.nodeType == 3) cursor_elem = cursor_elem.parentNode;
            cursor_elem.innerHTML += '<img style="width: ' + width + ';height: ' + height + ';margin: ' + vspace + ' ' + hspace + ' ' + vspace + ' ' + hspace + ';border: ' + border + ';' + style + '" src="' + src + '" alt="' + alt + '" />';
            dialog.dialog('close');
          },
          Cancel: function () {
            $('#jquery_dialog').dialog('close');
          },
        },
      });
    }
  }

  insert_font_size_change_tinymce(ed: any, value: any) {
    //var document_elem = ed.getDoc();
    try {
      var part_elems = ed.getDoc().body.children;
      for (var i in part_elems) {
        try {
          var elem = part_elems[i];
          elem.style.fontSize = value + 'pt !important';
        } catch (err) {
          console.log(err);
          console.log('Error while applying font size for elements in a part');
        }
      }
    } catch (err) {
      console.log(err);
      console.log('Error while applying font size for entire part');
    }
    return;
    /*
  		let scope = this;
  		var selection = ed.selection;
  		var start = selection.getRng().startContainer;
  		var end = selection.getRng().endContainer;
  		var common_node = selection.getNode();
  		if(start == end){
    		var parent = start.parentNode;    
    		var innerHTML = parent.innerHTML;
    		var b_offset = selection.getSel().baseOffset;
    		var e_offset = selection.getSel().extentOffset;
    		var start_position = 0;
    		var end_position = 0;
    		if(b_offset < e_offset){
      			start_position = b_offset;
      			end_position = e_offset;
    		}else{
      			start_position = e_offset;
      			end_position = b_offset;
    		}
    		if(start_position == end_position && false)
      			parent.innerHTML = innerHTML.slice(0, start_position) + '<span style="font-size: ' + value + 'pt;"></span>' + innerHTML.slice(end_position, innerHTML.length);
    		else
      			parent.innerHTML = innerHTML.slice(0, start_position) + '<span style="font-size: ' + value + 'pt;">' + innerHTML.slice(start_position, end_position) + '</span>' + innerHTML.slice(end_position, innerHTML.length);
    		return;
  		}
  		var start_parent = start.parentNode;
  		var prev_child   = start;
  		while(start_parent && start_parent != common_node){
    		prev_child = start_parent;
    		start_parent = start_parent.parentNode;
  		}
  		start_parent = prev_child;
  		var end_parent = end.parentNode;
  		prev_child   = end;
  		while(end_parent && end_parent != common_node){
    		prev_child = end_parent;
    		end_parent = end_parent.parentNode;
  		}
  		end_parent = prev_child;
  		start_parent = start_parent.nextSibling;
  		while(start_parent != end_parent){    
    		start_parent.style.fontSize = (value + 'pt');
    		start_parent = start_parent.nextSibling;
  		}
  		if(start_parent != start){
    		start_sibling = start.nextSibling;
    		while(start_sibling){
      			if(start_sibling.nodeName == '#text')
        			start_sibling = wrap_node(start_sibling, 'span');
      			start_sibling.style.fontSize = (value + 'pt');
      			start_sibling = start_sibling.nextSibling;
    		}
    		end_sibling = end.nextSibling;
    		while(end_sibling){
      			if(end_sibling.nodeName == '#text')
        			end_sibling = wrap_node(end_sibling, 'span');
      			end_sibling.style.fontSize = (value + 'pt');
      			end_sibling = end_sibling.nextSibling;
    		}
  		}  
  		//console.log(selection.getSel().baseNode.data);
  		//console.log(selection.getSel().extentNode.data);
  		//var bdata = selection.getSel().baseNode.data;
  		//var edata = selection.getSel().extentNode.data;
  		var start_position = 0;
  		var end_position = 0;
  		var b_offset = selection.getSel().baseOffset;
  		var e_offset = selection.getSel().extentOffset;
  		if(start == selection.getSel().baseNode){
    		start_position = b_offset;
    		end_position = e_offset;
  		}else{
    		start_position = e_offset;
    		end_position = b_offset;
  		}
  		if(start.nodeName == '#text')
    		scope.wrap_node(start, 'span', start_position, value);
  		else
    		start.style.fontSize = (value + 'pt');
  		if(end.nodeName == '#text')
    		scope.wrap_node(end, 'span', end_position, value, true);
  		else
    		end.style.fontSize = (value + 'pt');
    	*/
  }

  wrap_node(node: any, wrapper_node_name: any, pos: any, value: any, first: any) {
    var parent = node.parentNode;
    if (pos || pos > 0) {
      var innerHTML = parent.innerHTML;
      if (first) parent.innerHTML = '<span style="font-size: ' + value + 'pt;">' + innerHTML.slice(0, pos) + '</span>' + innerHTML.slice(pos, innerHTML.length);
      else parent.innerHTML = innerHTML.slice(0, pos) + '<span style="font-size: ' + value + 'pt;">' + innerHTML.slice(pos, innerHTML.length) + '</span>';
      return;
    }
    var wrapper = document.createElement(wrapper_node_name);
    parent.replaceChild(wrapper, node);
    wrapper.appendChild(node);
    return wrapper;
  }
}
